<template>
    <div class="wrapper">
        <div class="tit">
            <h1>{{editing ? 'Editar' : 'Nuevo' }} usuario</h1>
        </div>
        <div class="ctn_general">

            <div class="tabla_ctn subir_producto">
                <div class="tabla_filtros">
                    <div class="tfiltros_col">
                        <p>Datos del usuario</p>
                    </div>
                </div>
                <div class="datos_producto_ctn">
                    <form class="formulario_x2" @submit.prevent="onProcess">
                        <c-input type="text" :field="$v.username" id="username"
                                 classes="grupo_campos tipo_text x2" label="Correo electrónico *"
                                 length="50"/>
                        <c-input type="password" :field="$v.password" id="password" length="50"
                                 classes="grupo_campos tipo_text x2" :label="'Contraseña' + (editing ? '':' *')"/>
                        <c-input type="text" :field="$v.firstName" id="firstName"
                                 classes="grupo_campos tipo_text x2" label="Nombre *" length="50"/>
                        <c-input type="text" :field="$v.lastName" id="lastName"
                                 classes="grupo_campos tipo_text x2" label="Apellido *" length="50"/>
                        <c-input type="text" :field="$v.phone" id="phone"
                                 classes="grupo_campos tipo_text x2" label="Celular *" length="9"/>
                        <c-input type="select" :field="$v.roleId" id="roles"
                                 classes="grupo_campos tipo_text x2" label="Rol *" :items="roles"/>
                        <div class="grupo_campos">
                        </div>
                        <div class="grupo_boton">
                            <router-link tag="button" class="btn btn2" :to="{name:'users'}">{{editing ? 'Volver' :
                                'Cancelar'}}
                            </router-link>
                            <button class="btn" type="submit">Guardar</button>
                        </div>
                    </form>
                </div>
            </div>


        </div>
    </div>
</template>
<script>

    import CInput from '../common/CInput.vue'
    import UserService from "../../services/UserService";
    import alert from '../../util/alert'
    import {email, numeric, required, requiredIf} from 'vuelidate/lib/validators'
    import {roles} from '../../util/options'

    export default {
        props: {
            userIdIn: {
                type: Number,
                required: false
            }
        },
        components: {CInput},
        data() {
            return {
                editing: false,
                username: null,
                password: null,
                firstName: null,
                lastName: null,
                phone: null,
                roleId: null,
                roles
            }
        },
        validations: {
            username: {required, email},
            password: {
                required: requiredIf((model) => {
                    return !model.editing;
                })
            },
            firstName: {required},
            lastName: {required},
            phone: {required, numeric},
            roleId: {required},
        }, watch: {
            userIdIn: function () {
                if (this.userIdIn)
                    this.load(this.userIdIn);
            }
        },
        methods: {
            async load(userId) {
                const self = this;
                try {
                    const response = (await UserService.getUser(userId)).data.payload;
                    self.username = response.username;
                    self.password = response.password;
                    self.firstName = response.firstName;
                    self.lastName = response.lastName;
                    self.phone = response.phone;
                    self.roleId = response.roleId;
                    self.editing = true;
                } catch (e) {
                    alert.error("No se encontró usuario");
                }
            },
            async onProcess() {
                const self = this;
                self.$v.$touch();
                if (self.$v.$error) return;

                const data = {
                    username: self.username,
                    password: self.password,
                    firstName: self.firstName,
                    lastName: self.lastName,
                    phone: self.phone,
                    roleId: self.roleId
                };
                try {
                    if (!self.userIdIn) {
                        const response = (await UserService.add(data)).data.payload;
                        this.$router.push({name: 'user-editor', params: {userId: response.id}});
                    } else
                        await UserService.update(self.userIdIn, data);

                    self.editing = true;
                    alert.success("Se guardó información de usuario correctamente");
                } catch (e) {
                    console.error("Error al guardar usuario", e);
                    alert.error("Error al guardar usuario");
                }
            },

        },
        async mounted() {
            const self = this;
            if (self.userIdIn)
                self.load(self.userIdIn);
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/users/UserEditor.vue